export const TITLE = "Udruga „4 lista”";
export const SHORT_TITLE = "„4 lista”";
